var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/classes/environment/environment.ts
var Environment = class {
  context = {
    cdn: String(process.env.NEXT_PUBLIC_CDN),
    service: String(process.env.NEXT_PUBLIC_API),
    url: String(process.env.NEXT_PUBLIC_APP_URL),
    environment: String(process.env.NEXT_PUBLIC_ENV),
    key: ""
  };
  get() {
    return this.context;
  }
  set(name, value) {
    this.context[name] = value;
    if (name === "key") {
      this.context.service = `${this.context.service}/${value}`;
    }
  }
  update(data) {
    this.context = data;
  }
};

// src/components/alternate/Alternate.tsx
import React from "react";
import { jsx } from "react/jsx-runtime";
var Alternate = ({
  context: { page }
}) => {
  return /* @__PURE__ */ jsx(React.Fragment, {
    children: page.localizations ? page.localizations.map(({ title, language, path }, index) => /* @__PURE__ */ jsx("link", {
      rel: "alternate",
      title,
      hrefLang: language,
      href: path
    }, index)) : null
  });
};
var Alternate_default = Alternate;

// src/components/color-palette/ColorPalette.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var ColorPalette = ({
  context: {
    theme: { colors, neutrals }
  }
}) => {
  const css = (name, tones) => {
    const entries = Object.entries(tones);
    return entries.map(([key, value]) => {
      if (name.length == 2) {
        return `--${name}${key}: ${value};
                  --${name}${key}-RGB: ${value.replace(/[rgb|\(\)]/gm, "")};`;
      }
      return `--${name}${key}: ${value};`;
    }).join("");
  };
  return /* @__PURE__ */ jsx2("style", {
    type: "text/css",
    children: `:root {${[
      css("DN", neutrals.dark),
      css("LN", neutrals.light),
      css("PC", colors.primary),
      css("R", colors.red),
      css("Y", colors.yellow),
      css("G", colors.green),
      css("B", colors.blue),
      css("P", colors.purple),
      css("T", colors.teal)
    ].join("")}}`
  });
};
var ColorPalette_default = ColorPalette;

// src/components/error/Error.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var Error2 = ({
  code,
  type,
  message
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "error",
    children: [
      /* @__PURE__ */ jsxs("div", {
        className: "error-text",
        children: [
          /* @__PURE__ */ jsx3("h1", {
            children: code
          }),
          /* @__PURE__ */ jsx3("h4", {
            children: type
          }),
          /* @__PURE__ */ jsx3("p", {
            children: message
          })
        ]
      }),
      /* @__PURE__ */ jsx3("img", {
        src: "/images/wap-platform.svg",
        alt: "WAP Platform"
      })
    ]
  });
};
var Error_default = Error2;

// src/components/style/Style.tsx
import React2 from "react";
import { jsx as jsx4 } from "react/jsx-runtime";
var Style = ({
  context: {
    settings: { styles }
  }
}) => {
  return /* @__PURE__ */ jsx4(React2.Fragment, {
    children: styles ? /* @__PURE__ */ jsx4("style", {
      type: "text/css",
      children: styles
    }) : null
  });
};
var Style_default = Style;

// src/contexts/app/context.tsx
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState
} from "react";
import { setProperty } from "dot-prop";
import _ from "lodash";
import { jsx as jsx5 } from "react/jsx-runtime";
var AppContext = createContext(null);
var AppContextProvider = ({ children, value }) => {
  const [state, setState] = useState(value);
  useEffect(() => {
    if (_.isEqualWith(state, value))
      return;
    setState(value);
  }, [value]);
  const setData = useCallback((key, value2) => {
    if (state) {
      let result = { ...state };
      result = setProperty(state, key, value2);
      setState((...prevState) => ({ ...prevState, ...result }));
    }
  }, []);
  const setCustomData = useCallback((key, value2) => {
    if (state) {
      let result = { ...state };
      result = setProperty(state, key, value2);
      setState((...prevState) => ({ ...prevState, ...result }));
    }
  }, []);
  const getValue = () => {
    if (!state)
      return null;
    return {
      ...state,
      setData,
      setCustomData
    };
  };
  return /* @__PURE__ */ jsx5(AppContext.Provider, {
    value: getValue(),
    children
  });
};
var useApp = () => {
  const app2 = useContext(AppContext);
  if (app2) {
    return app2;
  }
  throw new Error("useApp must be used within a AppProvider.");
};

// src/hooks/useClone.ts
import React4 from "react";
function useClone(elem, props) {
  if (React4.isValidElement(elem)) {
    return React4.cloneElement(elem, props || {});
  }
  return null;
}

// src/hooks/useCombineRefs.ts
function useCombineRefs(...refs) {
  return (intance) => {
    refs.filter((ref) => ref).forEach((ref) => {
      if (typeof ref === "function") {
        ref(intance);
      } else {
        ref.current = intance;
      }
    });
  };
}

// src/hooks/useMobile.ts
var getNavigatorInstance = () => {
  if (typeof window !== "undefined") {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }
  return false;
};
var getUserAgent = (userAgent) => {
  const navigator2 = getNavigatorInstance();
  if (navigator2) {
    return navigator2.userAgent;
  }
  if (userAgent) {
    return userAgent;
  }
  throw new Error(
    "UserAgent must be given while detecting device on the server."
  );
};
var match = (userAgent = "", regex) => {
  return Boolean(getUserAgent(userAgent).match(regex));
};
var useChrome = (userAgent) => match(userAgent, /Chrome/i);
var useDolphin = (userAgent) => match(userAgent, /Dolphin/i);
var useEdge = (userAgent) => match(userAgent, /Edge/i);
var useFirefox = (userAgent) => match(userAgent, /Firefox|FxiOS/i);
var useIE = (userAgent) => match(userAgent, /IEMobile|MSIE|Trident/i);
var useMI = (userAgent) => match(userAgent, /MIUI Browser/i);
var useOpera = (userAgent) => match(userAgent, /OPR|Opera/i);
var useSafari = (userAgent) => match(userAgent, /^((?!chrome|android).)*safari/i);
var useYandex = (userAgent) => match(userAgent, /Yandex/i);
var useGecko = (userAgent) => match(userAgent, /Gecko/i);
var useGoanna = (userAgent) => match(userAgent, /Goanna/i);
var usePresto = (userAgent) => match(userAgent, /Presto/i);
var useTrident = (userAgent) => match(userAgent, /Trident/i);
var useMac = (userAgent) => match(userAgent, /Macintosh/i);
var useWindows = (userAgent) => match(userAgent, /Windows/i);
var useMobile = (userAgent) => match(userAgent, /iPhone|iPad|iPod|Android|Opera Mini|Windows Phone/i);
var useTablet = (userAgent) => match(
  userAgent && userAgent.toLowerCase(),
  /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i
);
var useBrowser = (userAgent) => !useMobile(userAgent);

// src/hooks/useMounted.ts
import { useState as useState2, useEffect as useEffect2 } from "react";
function useMounted() {
  const [mounted, setMounted] = useState2(false);
  useEffect2(() => {
    setMounted(true);
  }, []);
  return mounted;
}

// src/hooks/useOrientation.tsx
import { useCallback as useCallback2, useEffect as useEffect3, useState as useState3 } from "react";
var useOrientation = (orientation) => {
  const [targetReached, setTargetReached] = useState3(false);
  const handleChange = useCallback2((e) => {
    if (e.matches)
      setTargetReached(true);
    else
      setTargetReached(false);
  }, []);
  useEffect3(() => {
    const media = window.matchMedia(`(orientation: ${orientation})`);
    media.addEventListener("change", handleChange);
    if (media.matches)
      setTargetReached(true);
    return () => media.removeEventListener("change", handleChange);
  }, []);
  return targetReached;
};

// src/hooks/useSearchParams.ts
function useSearchParams(queryString) {
  return new URLSearchParams(
    queryString === void 0 ? window.location.search.slice(1) : queryString
  );
}

// src/hooks/useVar.ts
import { useRef } from "react";
function useVar(initialValue) {
  const { current } = useRef(initialValue);
  return current;
}

// src/hooks/useWidthResize.ts
import { useEffect as useEffect4, useState as useState4 } from "react";
var useWidth = () => {
  const [width, setWidth] = useState4(0);
  const handleResize = () => setWidth(window.innerWidth);
  useEffect4(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return width;
};

// src/utils/color.ts
var color_exports = {};
__export(color_exports, {
  rgb: () => rgb,
  shade: () => shade
});
var rgb = (hex) => {
  const color = hex.trim().replace("#", "");
  const red = parseInt(color.substring(0, 2), 16);
  const green = parseInt(color.substring(2, 4), 16);
  const blue = parseInt(color.substring(4, 6), 16);
  return [red, green, blue];
};
var shade = (color, percent) => {
  const [red, green, blue] = rgb(color);
  let r = red + percent;
  let g = green + percent;
  let b = blue + percent;
  r = Math.max(Math.min(255, r), 0).toString(16);
  g = Math.max(Math.min(255, g), 0).toString(16);
  b = Math.max(Math.min(255, b), 0).toString(16);
  const rr = (r.length < 2 ? "0" : "") + r;
  const gg = (g.length < 2 ? "0" : "") + g;
  const bb = (b.length < 2 ? "0" : "") + b;
  return `#${rr}${gg}${bb}`;
};

// src/utils/functions.ts
var functions_exports = {};
__export(functions_exports, {
  classnames: () => classnames
});
function classnames(...args) {
  const classNames = [];
  for (let i = 0; i < args.length; i++) {
    const arg = args[i];
    if (arg) {
      if (typeof arg === "string") {
        classNames.push(arg);
      } else if (typeof arg === "object") {
        for (const key in arg) {
          const value = arg[key];
          if (Object.prototype.hasOwnProperty.call(arg, key) && value) {
            if (typeof value === "string") {
              classNames.push(`${key}-${value}`);
            } else {
              classNames.push(key);
            }
          }
        }
      }
    }
  }
  return classNames.join(" ");
}

// src/utils/path.ts
var path_exports = {};
__export(path_exports, {
  app: () => app,
  asset: () => asset,
  url: () => url
});
import { NodeEnv } from "@wap-client/constants";
var app = (context, pathname) => {
  const origin = context.url || "/";
  if (!pathname || typeof pathname !== "string")
    return origin;
  if (pathname.indexOf("http") === 0) {
    return pathname;
  }
  if (context.environment === NodeEnv.Production) {
    return `/${pathname}`;
  }
  return `/${context.key}/${pathname}`;
};
var url = (context, pathname) => {
  const origin = context.url || "/";
  if (context.environment === NodeEnv.Production) {
    return `${origin}/${pathname}`;
  }
  return `${origin}/${context.key}/${pathname}`;
};
var asset = (context, path) => {
  if (!path)
    return "";
  if (path.indexOf("http") !== -1) {
    return path;
  } else {
    return `${context.cdn}/${path}`;
  }
};

// src/utils/string.ts
var string_exports = {};
__export(string_exports, {
  getDomainFromURL: () => getDomainFromURL,
  kebabcase: () => kebabcase,
  limitString: () => limitString,
  toLocale: () => toLocale
});
var limitString = (str, limit) => {
  if (str) {
    let crop = str.indexOf(" ", limit);
    if (crop === -1)
      return str;
    return str.substring(0, crop) + "...";
  }
  return "";
};
var getDomainFromURL = (url2) => {
  var _a;
  if (!url2)
    return "";
  let result = (_a = url2.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")) == null ? void 0 : _a.split("/")[0];
  return result;
};
var toLocale = (text) => {
  const letters = {
    \u0130: "i",
    I: "i",
    \u015E: "s",
    \u011E: "g",
    \u00DC: "u",
    \u00D6: "o",
    \u00C7: "c",
    i: "I",
    \u015F: "S",
    \u011F: "G",
    \u00FC: "U",
    \u00F6: "O",
    \u00E7: "C",
    \u0131: "I"
  };
  text = text.replace(/(([çiışğüöÖÇİIŞĞÜÖ]))/g, (letter) => {
    return letters[letter];
  });
  return text.toLowerCase();
};
var kebabcase = (text) => {
  text = toLocale(text);
  text = text.trim().replace(/[^a-z/0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-").toLowerCase();
  return text;
};
export {
  Alternate_default as Alternate,
  AppContext,
  AppContextProvider,
  ColorPalette_default as ColorPalette,
  Environment,
  Error_default as Error,
  Style_default as Style,
  color_exports as color,
  functions_exports as functions,
  getNavigatorInstance,
  getUserAgent,
  match,
  path_exports as path,
  string_exports as string,
  useApp,
  useBrowser,
  useChrome,
  useClone,
  useCombineRefs,
  useDolphin,
  useEdge,
  useFirefox,
  useGecko,
  useGoanna,
  useIE,
  useMI,
  useMac,
  useMobile,
  useMounted,
  useOpera,
  useOrientation,
  usePresto,
  useSafari,
  useSearchParams,
  useTablet,
  useTrident,
  useVar,
  useWidth,
  useWindows,
  useYandex
};
